import { ListingFilters, listingSortOptions } from "@/lib/fetch/listing";
import React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslations } from "next-intl";
import { ArrowUpDown } from "lucide-react";

type Props = {
  sort: ListingFilters["sort"];
  setSort: (sort: ListingFilters["sort"]) => void;
};

const SearchSortSelect: React.FC<Props> = ({ sort, setSort }) => {
  const t = useTranslations("search");
  return (
    <div className="flex items-center justify-end h-full">
      <Select
        value={sort}
        onValueChange={(value) => setSort(value as ListingFilters["sort"])}
      >
        <div>
          <SelectTrigger
            aria-label={t("sort-placeholder")}
            className="w-fit lg:w-[200px] font-medium text-sm"
          >
            <div className="flex flex-row items-center gap-2">
              <ArrowUpDown className="size-4 mr-1 lg:mr-0" />
              <p className="hidden lg:block">
                <SelectValue placeholder={t("sort-placeholder")} />
              </p>
            </div>
          </SelectTrigger>
        </div>
        <SelectContent>
          <SelectGroup>
            {listingSortOptions.map((option) => (
              <SelectItem key={option} value={option}>
                {t(`sort.${option}`)}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};

export default SearchSortSelect;
